import { createContext, useState, useEffect } from "react";
import { Navbar, NavbarTop, NavbarBottom } from "./Navbar";
import { useQuery } from "@tanstack/react-query";
import { Theme } from "./MUITheme";
import axios from "./Axios";

//Create new context to hold user info across multiple components.
export var GlobalContext = createContext();

//Import this component to assist with making standard web pages.
// <Root title="Home Page"><Home /></Root>
export function Root({ children }) {
	//Default user information. This will be updated when user logs in. Components
	//requiring user information can check login state by checking if user id is 0.
	var defaultUser = {
		id: 0,
		name: "Guest",
		email: "guest@huskydevelopment.com",
		last_login: Math.floor((new Date()).getTime() / 1000),
		permissions: 0,
		loading: true		//Use this loading key if waiting for user data to fully load.
	};

	//State variables.
    var [suffix, setSuffix] = useState("Husky Development");	//Default suffix for page titles.
	var [title, setTitle] = useState(suffix);					//Default title is the suffix.
	var [navbar, setNavbar] = useState(true);					//Default is to show full navbar.
	var [user, setUser] = useState(defaultUser);				//Default user is guest.
	var [theme, setTheme] = useState("default");				//User selectable theme.

	var { status, error } = useQuery({
		queryKey: ["user"],
		queryFn: () => axios.get("/user").then(({ data }) => { setUser(data); return data; }).catch(err => { setUser(defaultUser); return defaultUser; })
	});

	//This is meant to be a wrapper and is passed as the context for all pages to access.
	//Put any functions you want to be globally accessible here.
	var _ = window._ = {
		document: {
            //Use getter and setter to allow getting/changing page suffix.
			get suffix() { return suffix; },
			set suffix(newSuffix) { setSuffix(newSuffix); document.title = `${title} - ${newSuffix}`; },

			//Use getter and setter to allow getting/changing page title.
			get title() { return title; },
			set title(newTitle) {
				newTitle = newTitle && typeof newTitle === "string" ? newTitle : false;
				document.title = newTitle ? `${newTitle} - ${suffix}` : suffix;
				newTitle = newTitle ? newTitle : suffix;
				setTitle(newTitle);
			},

			//Use getter and setter to allow getting/changing navbar configuration.
			get navbar() { return navbar; },
			set navbar(newNavbar) { setNavbar(newNavbar); }
		},

		get user() { return user; },
		set user(newUser) { if (!newUser) { setUser(defaultUser); return; } setUser(newUser); }
	};

	//Wrap page in global context and theme so it can be accessed by components.
	return <GlobalContext.Provider value={_}>
		<Theme theme={theme}>
			<table className="master">
				<tbody>
					{!!navbar && <tr>
						<td>
							<table className="header">
								<tbody>{navbar === "bottom" ? <NavbarBottom /> : navbar === "top" ? <NavbarTop /> : <Navbar />}</tbody>
							</table>
						</td>
					</tr>}

					<tr>
						<td>
							<div className="body">
								<h1>{title}</h1>
								{children}
								<Footer />
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</Theme>
	</GlobalContext.Provider>;
}

//Import this component to assist with wrapping body content in section bubbles.
// <Root title="Home Page"><Section center><p>Hello World</p></Section></Root>
export function Section({ center, small, wide, full, collapse, children }) {
	var className = "wrapper" + (center ? " center" : "") + (collapse ? " collapse" : "");
	className += (small ? " small" : (wide ? " wide" : (full ? " full" : "")));
	
	return <div className={className}>
		<div className="section">{ children }</div>
	</div>;
}

function Footer() {
	return <div className="footer">Copyright 2025</div>;
}